import { useState, useImperativeHandle, forwardRef, useRef, React, useEffect } from 'react';
import styled from 'styled-components';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

const GoogleAddressInput = forwardRef((props, ref) => {
	const { className, placeholder, type, clickCountFn, clicked } = props;
	const { isDark } = useTheme();
	const theme = isDark ? darkTheme : lightTheme;
	const [value, setValue] = useState('');
	const [changed, setChanged] = useState(false);
	const [clickCount, setClickCount] = useState(0);
	const [defaultPlaceholder, setDefaultPlaceholder] = useState(placeholder);
	const [fontSize, setFontSize] = useState(16);

	const inputRef = useRef();

	useImperativeHandle(ref, () => ({
		setValue: (val) => {
			setValue(val);
			setChanged(true);
			if (val !== undefined) inputRef.current.style.borderColor = theme.line;
		},
		getValue: () => {
			if (changed)
				return value;
			else
				return "";
		},
		plusClickCount: () => {
			setClickCount(clickCount + 1)
		},
		getClickCount: () => {
			return clickCount;
		},
		setDefaultPlaceholder: (val) => {
			setDefaultPlaceholder(val)
			inputRef.current.style.borderColor = theme.pointRed;
		},
		reset: (val) => {
			setClickCount(0);
			setDefaultPlaceholder(val)
			inputRef.current.style.borderColor = theme.line;
		}
	}));

	useEffect(() => {
		setDefaultPlaceholder(placeholder);
	}, [placeholder])

	useEffect(() => {
		clickCountFn(className, clickCount);
	}, [clickCount, value])

	useEffect(() => {
		if (inputRef.current && value) {
			const element = inputRef.current;
			const scrollWidth = element.scrollWidth;
			const clientWidth = element.clientWidth;

			if (scrollWidth > clientWidth) {
				setFontSize(12);
			}
			else {
				setFontSize(16);
			}
		}
		else {
			setFontSize(16);
		}
	}, [value])

	function handleClick(e) {
		inputRef.current.style.borderColor = theme.primary;
		setDefaultPlaceholder('');
	}

	function handleChange(e) {
		setValue(e.target.value);
		setChanged(true);
	}

	function handleFocus(e) {
		clicked();
	}

	function handleBlur(e) {
		setClickCount(clickCount + 1);
		if (value === undefined) {
			setDefaultPlaceholder(placeholder);
			inputRef.current.style.borderColor = theme.pointRed;
		}
		else {
			inputRef.current.style.borderColor = theme.line;
		}
	}

	return <Input
		ref={inputRef}
		clickCount={clickCount}
		fontSize={fontSize}
		type={type}
		placeholder={defaultPlaceholder}
		value={value}
		className={`${className} ${changed ? "changed" : ""}`}
		onClick={handleClick}
		onChange={handleChange}
		onFocus={handleFocus}
		onBlur={handleBlur}
		readOnly />
});

export default GoogleAddressInput;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: ${props => props.fontSize}px;
	// font-size: max(12px, 0.7291666666666667vw);
	// line-height: 20px;

	padding: 0 0 4px 0;
	margin-top: 16px;
	// margin-top: max(12px, 0.8333333333333333vw);

	outline: none;
	border-width: 0 0 1px 0;
	border-color: ${props => props.theme.line};
	color: ${props => props.theme.text};
	background-color: ${props => props.theme.subBackground};

	::placeholder {
		color: ${props => props.clickCount < 1 || props.value !== '' ? props.theme.gray : props.theme.pointRed};
	}

  transition: all 0.5s ease-in-out;
`;
